<template>
  <div>
    <el-card shadow="always" style="box-shadow:none">
      <EditForm
        ref="editForm"
        :hxSpuCode="hxSpuCode"
        :hxSpuStatus.sync="hxSpuStatus"
        :optType="pageType"
      />
    </el-card>
    <el-card
      shadow="always"
      style="box-shadow:none"
      v-if="hxSpuStatus === 'Y'"
      class="mt-2"
    >
      <SkuTable :hxSpuCode="hxSpuCode" :disabled="pageType !== 'addSku'" />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SkuTable from '../components/sku-table'
export default {
  name: 'ecom-base-hxSpu-detail',
  components: { EditForm, SkuTable },
  data() {
    return { hxSpuStatus: '' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    hxSpuCode() {
      return this.params.hxSpuCode
    },
  },
}
</script>
